import React from "react";
import { useEditor, EDITOR_MODES } from "./store";
import Button from "@/components/ui/Button";
import { IoMdSkipBackward, IoMdPause, IoMdPlay, IoMdSkipForward } from "react-icons/io";
import { LuMousePointer2, LuScissors, LuMagnet, LuUndo2, LuRedo2, LuArrowRightToLine } from "react-icons/lu";
import { FiZap, FiMessageCircle } from "react-icons/fi";



export function ControlBar({ generationsOpen = false, onToggleGenerations, commentsOpen = false, onToggleComments }) {
  const isPlaying = useEditor((s) => s.isPlaying);
  const setPlaying = useEditor((s) => s.setPlaying);
  const split = useEditor((s) => s.splitClipAtPlayhead);
  const mode = useEditor((s) => s.mode);
  const setMode = useEditor((s) => s.setMode);
  const toJSON = useEditor((s) => s.toJSON);
  const loadFromJSON = useEditor((s) => s.loadFromJSON);
  const snappingEnabled = useEditor((s) => s.snappingEnabled);
  const toggleSnapping = useEditor((s) => s.toggleSnapping);
  const undo = useEditor((s) => s.undo);
  const redo = useEditor((s) => s.redo);
  const canUndo = useEditor((s) => s.undoStack.length > 0);
  const canRedo = useEditor((s) => s.redoStack.length > 0);
  return (
    <div className="flex items-center p-2 border-y border-secondary/40 flex-shrink-0 justify-between bg-primary-foreground/40">     
      
      {/* Mode Selector */}
      <div className="flex items-center gap-4">
        <div className="flex items-center rounded-md overflow-hidden">
          <button
            onClick={() => setMode(EDITOR_MODES.SELECT)}
            className={`flex items-center p-2 ${
              mode === EDITOR_MODES.SELECT
                ? "bg-primary text-primary-foreground"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer"
            }`}
            title="Select mode (V)"
          >
            <LuMousePointer2 className="w-4 h-4" />
          </button>
          <button
            onClick={() => setMode(EDITOR_MODES.CUT)}
            className={`flex items-center p-2 ${
              mode === EDITOR_MODES.CUT
                ? "bg-primary text-primary-foreground"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer"
            }`}
            title="Cut mode (C)"
          >
            <LuScissors className="w-4 h-4" />
          </button>
          <button
            onClick={() => setMode(EDITOR_MODES.TRACK_SELECT_FORWARD)}
            className={`flex items-center p-2 ${
              mode === EDITOR_MODES.TRACK_SELECT_FORWARD
                ? "bg-primary text-primary-foreground"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer"
            }`}
            title="Track select forward (A)"
          >
            <LuArrowRightToLine className="w-4 h-4" />
          </button>
        </div>

        {/* Snapping Toggle */}
        <button
          onClick={toggleSnapping}
          className={`flex items-center p-2 rounded-md cursor-pointer ${
            snappingEnabled
              ? "bg-primary text-primary-foreground hover:bg-primary/80"
              : "bg-secondary text-secondary-foreground hover:bg-secondary/80 "
          }`}
          title={snappingEnabled ? "Snapping enabled (click to disable)" : "Snapping disabled (click to enable)"}
        >
          <LuMagnet className="w-4 h-4" />
        </button>

        <div className="flex items-center rounded-md overflow-hidden">
          <button
            onClick={undo}
            disabled={!canUndo}
            className="flex items-center p-2 bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer disabled:opacity-40 disabled:cursor-default"
            title="Undo (Cmd/Ctrl+Z)"
          >
            <LuUndo2 className="w-4 h-4" />
          </button>
          <button
            onClick={redo}
            disabled={!canRedo}
            className="flex items-center p-2 bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer disabled:opacity-40 disabled:cursor-default"
            title="Redo (Cmd/Ctrl+Shift+Z)"
          >
            <LuRedo2 className="w-4 h-4" />
          </button>
        </div>

        
      </div>
      <div className='flex items-center gap-2'>
        <Button type='secondary' icon={isPlaying ? <IoMdPause className='w-4 h-4' /> : <IoMdPlay className='w-4 h-4' />} onClick={() => setPlaying(!isPlaying)} />
      </div>
      <div className='flex items-center gap-2'>
        <Button
          title='GenAI'
          type={generationsOpen ? 'primary' : 'secondary'}
          icon={<FiZap className='w-4 h-4' />}
          onClick={onToggleGenerations}
        />
        <Button
          title='Comments'
          type={commentsOpen ? 'primary' : 'secondary'}
          icon={<FiMessageCircle className='w-4 h-4' />}
          onClick={onToggleComments}
        />
      </div>
    </div>
  );
}

